export default __webpack_public_path__ + "static/media/jen-ken_logo.20ab9a32.jpg";